import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgSubtract2 = function SvgSubtract2(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#subtract2_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 20.485c-4.674-4.673-4.674-12.297 0-16.97 4.673-4.674 12.297-4.674 16.97 0 4.674 4.673 4.674 12.297 0 16.97-4.673 4.674-12.297 4.674-16.97 0zM19.613 12c0-.53-.464-.994-.995-.994H7.35c-.53 0-.994.464-.994.994s.464.994.994.994h11.27c.265 0 .53-.132.695-.298.166-.166.299-.43.299-.696z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "subtract2_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.984)"
  }))));
};

export default SvgSubtract2;